import { render } from "./DocTinkoffView.vue?vue&type=template&id=627cb71f"
import script from "./DocTinkoffView.vue?vue&type=script&lang=js"
export * from "./DocTinkoffView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__